import * as React from "react";
import { Link } from "gatsby";

function AutoLink({ to, href, children, ...props } = {}) {
  to = to || href
  return !to ? (
    <>{children}</>
  ) : to.startsWith("/") ? (
    <Link to={to} {...props}>
      {children}
    </Link>
  ) : (
    <a href={to} {...props}>
      {children}
    </a>
  );
}

export default AutoLink;
